import { Observable, of } from 'rxjs';

export class MockAuthenticationService {

  logout(): Observable<boolean> {
    return of(true);
  }
}
